import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { RestLink } from 'apollo-link-rest'

import { logoutOnUnauthorizedLink } from './logout-on-unauthorized-link'
import { getAuthToken } from '../hooks'
import { detectActiveContext } from '../components/context-switcher/compute-contexts'

export const httpLink = new HttpLink({ uri: `${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_GRAPHQL_PATH}` })

const restLink = new RestLink({
  uri: process.env.REACT_APP_API_HOST,
  headers: {
    'Content-Type': 'application/json',
  },
})

// FLIGHT-574: serialise the active portal from the URL so the API can read it.
// Format: `kind=donor;id=20196` / `kind=charity;id=42` / `kind=advisor` / `kind=admin`.
// Kind 'fund' from detectActiveContext renames to 'donor' on the wire to match
// user-facing vocabulary (fund stays as the data-layer noun).
function buildActivePortalHeader() {
  if (typeof window === 'undefined') return null
  const ctx = detectActiveContext(window.location.pathname)
  if (!ctx) return null
  const kind = ctx.kind === 'fund' ? 'donor' : ctx.kind
  if (ctx.id == null) return `kind=${kind}`
  return `kind=${kind};id=${ctx.id}`
}

export const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = getAuthToken()

  // Forward instance branding override so emails use the sender's branding
  const brandingId = sessionStorage.getItem('session_branding_id')

  const activePortal = buildActivePortalHeader()

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
      ...(brandingId && { 'x-branding-id': brandingId }),
      ...(activePortal && { 'x-active-portal': activePortal }),
    },
  }
})

export const client = new ApolloClient({
  link: ApolloLink.from([logoutOnUnauthorizedLink, authLink, restLink, httpLink]),
  cache: new InMemoryCache(),
})
